import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { getIconFor, useIconFor } from "./hooks/useIconFor";
export const PropertiesIcon = ({ countryCode, featureKey, icons, ariaHidden = true, alt, }) => {
    const imgSrc = useIconFor(featureKey, countryCode, icons);
    const { translate } = useI18n();
    if (!imgSrc)
        return null;
    return (_jsx("img", { "data-token": featureKey, "aria-hidden": ariaHidden, src: imgSrc, className: "properties__icon", title: translate(featureKey), alt: alt ?? translate(featureKey) }));
};
export const PropertiesIconList = ({ className, countryCode, properties, maxIcons, icons, }) => (_jsx("div", { className: `properties-icon-list ${className || ""}`, children: properties
        .map((featureKey) => ({
        iconSrc: getIconFor(featureKey, countryCode, icons),
        featureKey,
    }))
        .filter(({ iconSrc }) => iconSrc !== undefined)
        .slice(0, maxIcons)
        .map(({ featureKey }) => (_jsx(PropertiesIcon, { countryCode: countryCode, featureKey: featureKey, icons: icons }, featureKey))) }));
